<template>
  <div
    ref="sidebar"
    :style="{
      '--sidebar-top-position': `${sidebarTopPosition}px`,
    }"
    :class="{
      'sidebar--active': isShowing,
      'sidebar--progress': isProgressPage,
    }"
    class="sidebar scrollbar-default">
    <main-sidebar-client-links
      v-if="isClientPage"
      @hideSidebar="$emit('hideSidebar')" />

    <main-sidebar-games
      v-else
      @hideSidebar="$emit('hideSidebar')" />

    <main-sidebar-footer
      v-if="isMobile"
      @hideSidebar="$emit('hideSidebar')" />
  </div>
</template>

<script>
import MainSidebarGames from 'Components/Sidebar/MainSidebarGames.vue';
import MainSidebarClientLinks from 'Components/Sidebar/MainSidebarClientLinks.vue';
import MainSidebarFooter from 'Components/Sidebar/MainSidebarFooter.vue';

export default {
  name: 'MainSidebar',

  components: {
    MainSidebarGames,
    MainSidebarClientLinks,
    MainSidebarFooter,
  },

  props: {
    isShowing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      sidebarTopPosition: 0,
    };
  },

  computed: {
    isMobile() {
      return this.$store.state.userDevice.innerWidth < 1024;
    },

    isVisibleSearchIcon() {
      /* Показываем иконку поиска только на "игровых" роутах */
      return this.$route.name.startsWith('game__');
    },

    // Костыль чтобы починить на планшете в заказе у клиента гигантский отступ сверху (виноват сайдбар)
    isProgressPage() {
      return this.$route.name === 'client__order-progress';
    },

    isClientPage() {
      return this.$route.name.startsWith('client');
    },
  },

  watch: {
    isShowing: {
      handler(newValue) {
        if (newValue && this.isMobile) {
          this.sidebarTopPosition = this.$parent.$refs.contentWrapper.getBoundingClientRect().top;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .sidebar {
    --sidebar-top-position: 88px;

    transform: translateX(0);
    transition: transform .15s ease-out;
    position: fixed;
    z-index: 2147483100; // gg intercom
    top: var(--sidebar-top-position);
    left: -100%;
    width: 100%;
    height: calc(100vh - var(--sidebar-top-position));
    overflow: auto;
    background-color: $color--basic-black;
  }

  .sidebar--active {
    transform: translateX(100%);
  }

  .sidebar--overflowed {
    overflow: hidden;
  }

  .sidebar__search {
    padding-top: 25px; // margin ломает эффект оверлея при раскрытом поиске
    z-index: 2;
  }

  @media screen and #{$screen-less-than-1024} {
    .sidebar {
      padding-bottom: 120px; // iphone stuff
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .sidebar {
      width: 0;
      max-height: calc(100vh - 66px);
      height: 100%;
      position: sticky;
      top: 0;
      left: auto;
      background-color: $color--basic-black;
      z-index: 100;
      align-self: start;
      padding-bottom: 30px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
      transition: opacity var(--transition-opacity-time) var(--transition-opacity-easing);
      transform: translateX(0);
    }

    .sidebar--progress {
      position: fixed;
    }

    .sidebar--active {
      width: $size-pc-sidebar;
      opacity: 1;
      pointer-events: auto;
    }
  }
</style>
